import { hasNoWritePermission } from '@/helpers/spreadsheetHelper';
import { MODAL_CREATE_ACCOUNT, MODAL_MAKE_COPY } from './constants';

const getAddRowsSubMenu = ({
  user,
  dispatch,
  currentFile,
  agGrid,
  _addRow,
  showModal,
  selectedRowCount,
  isPreviewMode,
  showPreviewModeUpsellModal,
}) => {
  const getRowOrRows = selectedRowCount > 1 ? 'rows' : 'row';

  const subMenuItem = (name, showPreviewModeUpsellModal, rowCorrectingIndex = 0) => ({
    name,
    action: user?.is_anonymous
      ? () => dispatch(showModal({ name: MODAL_CREATE_ACCOUNT }))
      : hasNoWritePermission(currentFile)
      ? () => dispatch(showModal({ name: MODAL_MAKE_COPY }))
      : isPreviewMode
      ? () => {
          return showPreviewModeUpsellModal();
        }
      : () => _addRow(rowCorrectingIndex, agGrid),
  });

  return [
    subMenuItem(`Insert ${selectedRowCount} ${getRowOrRows} above`, showPreviewModeUpsellModal),
    subMenuItem(
      `Insert ${selectedRowCount} ${getRowOrRows} below`,
      showPreviewModeUpsellModal,
      selectedRowCount
    ),
  ];
};

export default getAddRowsSubMenu;
